<template>
  <div class="py-4 container-fluid">

    <div class="col-12 pb-0  mb-2">
        <div class="card shadow-lg  card-profile-top">
          <div class="card shadow-lg">
            <div class="card-body p-3">
              <div class="row gx-4">
                <div class="col-auto my-auto">
                    <div class="h-100"><h5 class="mb-1">Histórico de  Pedidos</h5><p class="mb-0 font-weight-bold text-sm">Pedidos concluídos</p>
                  </div>
                </div>
                <div class="mx-auto mt-3 col-lg-4 col-md-4 col-sm-4  my-sm-auto ms-sm-auto me-sm-0">
                  <div class="tags-container">
                        <span 
                          v-for="(tag, index) in data_sincroniza.operacoes" 
                          :key="index" 
                          class="tag"
                        >
                          {{ tag }}
                          <button @click="removeTag(data_sincroniza, tag)" class="remove-btn">&times;</button>
                        </span>
                        <input
                          type="numeric"
                          v-model="data_sincroniza.textTag"
                          @keydown.enter.prevent="addTag(data_sincroniza)"
                          placeholder="Digite a operação"
                          class="tag-input"
                        />
                        <span class="tag-erro" v-if="data_sincroniza.error_operacao"> {{ data_sincroniza.error_operacao  }}</span>
                        
                        <span class="tag-erro" v-if=" data_sincroniza.error"> {{ data_sincroniza.error  }}</span>
                        <span class="tag-erro" v-if=" data_sincroniza.loading"> 
                          <div class="spinner-border text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </span>
                  </div>
                </div>                
              <div class="mx-auto mt-3 col-lg-4 col-md-4 col-sm-4  my-sm-auto ms-sm-auto me-sm-0">
                <div class="nav-wrapper position-relative end-0">
                  <ul class="p-1 bg-transparent nav nav-pills nav-fill" role="tablist">


                    <li class="nav-item col-lg-12 col-md-12 col-sm-12  my-auto">
                      
                      <label for="start-date">Data inicial:</label>
                      <input type="date" v-model="data_sincroniza.data_inicial" id="start-date" name="start-date">
                    

                    </li>
                    <li class="nav-item col-lg-12 col-md-12 col-sm-12 my-auto">

                      <label for="end-date">Data final:</label>
                      <input type="date" v-model="data_sincroniza.data_final" id="end-date" name="end-date">

                    </li>
                    <li class="nav-item col-lg-12 col-md-12 col-sm-12 my-auto">

                        <argon-button
                            @click="doConsultar()"
                            variant="gradient"
                            color="warning"
                            fullWidth
                            :disabled="sincronizar.show"
                            size="lg">
                            Consultar
                        </argon-button>

                    </li>
                  </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="sincronizar.show">
          <div class="col-12 pb-5 card-header mb-5" v-if="sincronizar.show">

            <div class="d-flex flex-column d-flex align-items-center ">

                  <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>

            </div>

            <div class="progress-wrapper">
                <div class="progress-info">
                  <div class="progress-percentage">
                    <span class="text-sm font-weight-bold">{{sincronizar.progress}}%</span>
                  </div>
                </div>
                <div class="progress">
                  <div
                    class="progress-bar bg-primary"
                    role="progressbar"
                    :aria-valuenow="sincronizar.progress"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    :style="{ width: sincronizar.progress + '%' }"
                  ></div>
                </div>
            </div>
            
          </div>

          <div class="col-12 pb-5 card-header mb-5" v-if="sincronizar.success && !sincronizar.show">

            <div class="alert alert-success d-flex align-items-center" role="alert">
              <i class="fas fa-check-circle text-success me-2"></i>
              <span>Operação realizada com sucesso!</span>
            </div>

          </div>


        </div>
    </div>

   
    <div class="row">
      <div class="col-12">
        <pedidos-historico-table  :pedidos="pedidos" :doUpdate="doUpdate" :doAddTag="doAddTag" :doRemoveTag="doRemoveTag"  :doRemovePedido="doRemovePedido" :searchCall="searchCall" />
        <loading  v-if="isLoading" />

          <div class="dataTable-bottom">
            <div class="dataTable-info">
              Mostrando {{ current_page * per_page + 1 }} até 
              <select v-model.number="per_page" @change="getPaginas(0)">
                <option v-for="option in per_page_options" :key="option" :value="option">
                  {{ option === -1 ? 'Todos' : option }}
                </option>
              </select> de 
              {{ total_count }} {{ local_page }}
            </div>



          <nav class="dataTable-pagination">
            <ul class="dataTable-pagination-list">

              <!-- Botão anterior -->
              <li @click="getPaginas(Math.max((current_page - 1) * per_page, 0))" 
                  class="pager" 
                  :class="{ disabled: current_page === 0 }">
                <a href="#">‹</a>
              </li>

              <!-- Novo range limitado -->
              <li 
                v-for="page in paginatedPages" 
                :key="page"
                @click="getPaginas((page - 1) * per_page)" 
                :class="{ active: current_page === (page - 1) }">
                <a href="#">{{ page }}</a>
              </li>

              <!-- Próximo -->
              <li @click="getPaginas(Math.min((current_page + 1) * per_page, (total_pages - 1) * per_page))" 
                  class="pager"
                  :class="{ disabled: current_page === total_pages - 1 }">
                <a href="#">›</a>
              </li>
            </ul>
          </nav>

          </div>

      </div>
    </div>

  </div>
</template>

<script>

import GoogleMapsApiLoader from 'google-maps-api-loader'

import { defineComponent, ref } from 'vue';


import PedidosHistoricoTable from "./components/PedidosHistoricoTable.vue";
import ProjectsTable from "./components/ProjectsTable.vue";
import ArgonButton from "@/components/ArgonButton.vue";

import Loading from "./components/Loading.vue";

import fintailapi from "../api";

const { v4: uuidv4 } = require('uuid');

import { useToast } from "vue-toastification";

export default defineComponent({
  name: "tables",
  components: {
    PedidosHistoricoTable,
    ProjectsTable,
    ArgonButton,
    Loading
  },
  data() {
    return {
      map: null,
      google: null,
      data_sincroniza: {data_inicial:"", data_final:"", operacoes:[]},
      sincronizar: { show:false, progress: 0 },
      modo : "view",
      pedidos: [],
      current_page:0,
      offset:0,
      current_offset:0,
      total_count: 0,
      total_pages: 0,
      isLoading:true,
      showMapa:true,
      per_page: 10,
      per_page_options: [10, 30, 50, 100], // -1 = todos
      toast : useToast(),
      local_page : "Pedidos",
    };
  },
  async mounted() {
    
    this.getPedidos(0)
    

  },
  computed: {
    paginatedPages() {
      const pagesPerBlock = 10; 
      const currentBlock = Math.floor(this.current_page / pagesPerBlock);

      const start = currentBlock * pagesPerBlock + 1;
      const end = Math.min(start + pagesPerBlock - 1, this.total_pages);

      const pages = [];
      for (let p = start; p <= end; p++) pages.push(p);

      return pages;
    }
  },
  methods: {
    doUpdate(event, pedido) {

        this.sincronizar.show = true
        this.sincronizar.progress = 25

        fintailapi
        .put(`/pedidos/${pedido.id_pedido}`,  pedido)
        .then((response) => {
            this.sincronizar.progress = 100
            this.sincronizar.show = false

            //this.getPedidos(this.current_offset)
        })
        .catch((error) => {
          this.sincronizar.show = false
          this.sincronizar.error = error.message
        })

    },
    doAddTag(pedido, codigo_embalagem) {

        pedido.codigo_embalagem = codigo_embalagem
        pedido.error = null
        pedido.loading = true

        fintailapi
        .post(`/pedidos/embalagem/${pedido.id_pedido}`,  pedido)
        .then((response) => {
          
            //this.sincronizar.progress = 100
            //this.sincronizar.show = false
            pedido.loading = false

            pedido.id_embalagem = response.data.id_embalagem

            pedido.embalagens.push({ id_embalagem : response.data.id_embalagem, codigo_embalagem: codigo_embalagem.trim()});
          
            
        })
        .catch((error) => {
          
          pedido.error = "Unidade de Transporte "+codigo_embalagem+" não cadastrada."
          pedido.embalagens.pop();
          pedido.loading = false

          this.toast.error(`Erro:${ error.response.data.error }, tente novamente.`);
          
        })


    },
    doRemoveTag(pedido, id_embalagem) {

      this.sincronizar.show = true
      this.sincronizar.progress = 20


      fintailapi
      .delete(`/pedidos/embalagem/${pedido.id_pedido}/${id_embalagem}`)
      .then((response) => {

          this.sincronizar.progress = 100
          this.sincronizar.show = false

          this.getPedidos(0)

      })
      .catch((error) => {
        this.sincronizar.show = false
        this.sincronizar.error = error.message
      })

    },
    removeTag(pedido, tag) {
       console.log(tag)
      if (!pedido.operacoes) pedido.operacoes = [];
      pedido.operacoes = pedido.operacoes.filter(t => t !== tag);

    },
    addTag(pedido) {
        this.data_sincroniza.error_operacao=null;
        fintailapi
        .get(`/operacoes/${pedido.textTag}`)
        .then((response) => {

            if(!pedido.operacoes)pedido.operacoes = [];
            if (pedido.textTag.trim() !== "" && !pedido.operacoes.includes(pedido.textTag)) {
              pedido.operacoes.push( pedido.textTag.trim() );
              pedido.textTag = "";
            }
        
        })
        .catch((error) => {
            this.data_sincroniza.error_operacao=`Operação ${pedido.textTag} não Localizada`;
        })


    },
    doRemovePedido(pedido) {

        fintailapi
        .delete(`/pedidos/${pedido.id_pedido}`)
        .then((response) => {

            this.sincronizar.progress = 100
            this.sincronizar.show = false

            this.getPedidos(0)

        })
        .catch((error) => {
          this.sincronizar.show = false
          this.sincronizar.error = error.message
        })


    },
    doConsultar() {
      this.getPedidos(0);  
    },
    getPaginas(offset) {

        if (this.total_count > 0 && (offset < 0 || offset >= this.total_count)) return; // Impede valores inválidos
        
        this.current_offset = offset;

        this.getPedidos(offset);       

    },
    getPedidos(offset) {

        this.isLoading = true
        
        fintailapi
        .post(`/pedidos/historico?offset=${offset}&limit=${this.per_page}`, this.data_sincroniza)
        .then((response) => {

          this.isLoading=false
 
          this.pedidos = response.data.pedidos;

          this.current_page = offset / this.per_page; // Atualiza a página com base no offset
          this.total_count = response.data.count;
          this.total_pages = Math.ceil(response.data.count / this.per_page);

        })
        .catch((error) => {
          this.toast.error(`Erro:${ error.response.data.error }, tente novamente.`);
        })

    },
    searchCall(campo, termo) {

      fintailapi
        .get(`/pedidos/pesquisar/campo?term=${termo}&field=${campo}`)
        .then((response) => {
          this.current_offset = 0;
          this.current_page = 0 / this.per_page; // Atualiza a página com base no offset
          this.total_count = response.data.count;
          this.total_pages = Math.ceil(response.data.count / this.per_page);
          this.pedidos = response.data.rows;
        })
        .catch((error) => {
          this.toast.error(`Erro:${ error.response.data.error }, tente novamente.`);
        })

    },
  },
  created() {

      this.modo = this.$route.params.id||'view';

  },

});

</script>
